module.exports = __webpack_public_path__ + "img/lluvia_blue.9dc63ebf.svg";